import NightingaleChart from "../../../Components/Charts/RetailNightingleChart";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark";

const fuel_type_retails = async (body) => {
  try {
    const res = await axInst.post("retails/fuel-type-retails", body);
    return res.data;
  } catch (error) {
    console.error(error);
  }
};

const FuelTypewise = () => {
  const { data, submitted } = useSelector((e) => e.filters);

  const {
    data: fuelType,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["fuel", submitted],
    queryFn: () => fuel_type_retails(data),
    cacheTime: 0,
    staleTime: 0,
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  return (
    <div className="relative">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />
      {!isFetching && !isError && (
        <div>
          <NightingaleChart
            data={fuelType}
            heading="Fuel Type Wise Retail"
            h="230"
          />
        </div>
      )}
    </div>
  );
};
export default FuelTypewise;
